import React from 'react'
import { useTranslation } from 'react-i18next'
import { Avatar, Box, CopyButton, Highlight } from '@node-space/ui-components'
import type { CardTransaction } from 'services/CardService'
import { truncateId } from 'utils/string'
import { formatCurrency, getStatusTranslationKey, getStatusType } from '../../helpers/cards'

interface CardTransactionDetailsHeaderProps {
  transaction: CardTransaction
}

export const CardTransactionDetailsHeader = ({
  transaction,
}: CardTransactionDetailsHeaderProps) => {
  const { t } = useTranslation()

  const amount = transaction.settledAmount || transaction.authorizedAmount
  const formattedAmount = formatCurrency(amount, transaction.asset)
  const truncatedId = truncateId(transaction.id)

  return (
    <Box flex gap={16} align="start">
      <Avatar type="currency" name={transaction.asset} size="large" />
      <Box flexCol gap={4} className="flex-1 min-w-0">
        <p className="text-body-regular text-foreground-subdued">
          {t('customers.cardTransactionDetails.cardPurchase')}
        </p>
        <h2 className="text-h2 text-foreground-prominent">{formattedAmount}</h2>
        <Box flex align="center" gap={4}>
          <p className="text-body-regular text-foreground-prominent">{truncatedId}</p>
          <CopyButton copyText={transaction.id} />
        </Box>
        <Box paddingT={4}>
          <Highlight type={getStatusType(transaction.status)}>
            {t(getStatusTranslationKey(transaction.status))}
          </Highlight>
        </Box>
      </Box>
    </Box>
  )
}
